// extracted by mini-css-extract-plugin
module.exports = {"line_login":"CallbackLine_line_login_1KOeO","text":"CallbackLine_text_1wDrT","mask":"CallbackLine_mask_SP2iw","vibration":"CallbackLine_vibration_2vp5R"};